import { ICountryOptionsState } from './country-options.state';
import { createReducer, on } from '@ngrx/store';
import {
  loadCountryOptions,
  loadCountryOptionsSuccess,
} from './country-options.actions';

export const initialState: ICountryOptionsState = {
  countryOptions: [],
  countryOptionsLoading: false,
};

export const countryOptionsReducer = createReducer(
  initialState,
  on(loadCountryOptions, (state) => {
    return {
      ...state,
      countryOptionsLoading: true,
    };
  }),
  on(loadCountryOptionsSuccess, (state, { countryOptions }) => {
    return {
      ...state,
      countryOptions: countryOptions || [],
      countryOptionsLoading: false,
    };
  })
);
